import React from 'react';
import ContactUs from '../components/ContactForm/contactForm';
import Footer from '../components/Footer/Footer';


const Inscription = () => {
    return (
        <>
            
            <ContactUs/>
           <Footer/>
        </>
    )
}

export default Inscription
